import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { jsmEmailDomainsListResource } from '@atlassian/jira-router-resources-jsm-get-email-domains-list/src/index.tsx';
import { productsJsmOrganizationDetailsResource } from '@atlassian/jira-router-resources-jsm-organization-details/src/index.tsx';
import { entitlementsOrganizationQueryResource } from '@atlassian/jira-router-resources-service-desk-customer-service-organization-details/src/services/entitlements-organization-query-resource/index.tsx';
import { uiOrganizationDetailsPageQueryResource } from '@atlassian/jira-router-resources-service-desk-customer-service-organization-details/src/services/ui-organization-details-page-query-resource/index.tsx';
import { servicedeskOrganizationDetailsRoute } from '@atlassian/jira-router-routes-servicedesk-organizations-routes/src/servicedeskOrganizationDetailsRoute.tsx';
import {
	APP_NAMES,
	toPackageName,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { ServicedeskOrganizationDetails, LazyServicedeskOrganizationDetails } from './ui/index.tsx';

export const servicedeskOrganizationDetailsRouteEntry = createEntry(
	servicedeskOrganizationDetailsRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
		},
		component: ServicedeskOrganizationDetails,
		forPaint: [LazyAtlassianNavigation, LazyServicedeskOrganizationDetails],
		perfMetricKey: 'jsm-organization-details-component-load',
		meta: {
			reporting: {
				id: APP_NAMES.ORGANIZATION_DETAILS,
				packageName: toPackageName(APP_NAMES.ORGANIZATION_DETAILS),
				teamName: 'boysenberry',
			},
		},
		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			entitlementsOrganizationQueryResource,
			uiOrganizationDetailsPageQueryResource,
			productsJsmOrganizationDetailsResource,
			jsmEmailDomainsListResource,
		],
	}),
);
